import {
  Button,
  Col,
  DatePicker,
  Divider,
  Form,
  Modal,
  Row,
  Select,
  Tabs,
} from 'antd';
import ObjectCardMainDynamic from './ObjectCardMainDynamic';
import PrimaryConditionsDynamic from './PrimaryConditionsDynamic';
import ObjectCardAdditionalDynamic from './ObjectCardAdditionalDynamic';
import ObjectCardUnderDynamic from './ObjectCardUnderDynamic';
import type { TabsProps } from 'antd';
import { useImmerReducer } from 'use-immer';
import api from '@modules/Quotation/services';
import { useEffect, useState } from 'react';

const ObjectCardModalDynamic = ({
  isHaveDicti,
  closeObjectModal,
  isLoading,
  agrIsn,
  objAttributesList,
  userForeignId,
  saveObject,
  objAttrData,
  productIsn,
  AdvancedContractorSearch,
  modalSetting,
  saveObjectCond,
  productSelectedQuotation,
  mainForm,
  selectedObj,
  primaryCondForm,
  additionalObjAttributesForm,
  additionalUnderForm,
  agrCond,
  quotationData,
  dicti,
  openTypeId,
}) => {
  const [items, setItems] = useState<TabsProps['items']>([]);

  useEffect(() => {
    if (!isHaveDicti || dicti) {
      setItems([
        {
          key: '1',
          label: 'Основное',
          children: (
            <ObjectCardMainDynamic
              agrIsn={agrIsn}
              dicti={dicti}
              saveObject={saveObject}
              AdvancedContractorSearch={AdvancedContractorSearch}
              modalSetting={modalSetting}
              mainForm={mainForm}
              selectedObj={selectedObj}
              productIsn={productIsn}
            />
          ),
        },
        {
          key: '2',
          label: 'Первичные условия',
          children: (
            <PrimaryConditionsDynamic
              modalSetting={modalSetting}
              saveObjectCond={saveObjectCond}
              productSelectedQuotation={productSelectedQuotation}
              primaryCondForm={primaryCondForm}
              selectedObj={selectedObj}
              agrCond={agrCond}
              carForm={mainForm}
              productIsn={productIsn}
              quotationData={quotationData}
            />
          ),
        },
      ]);
    }
  }, [dicti, selectedObj]);
  useEffect(() => {
    if (items && items.length === 2) {
      if (
        objAttributesList.additional &&
        objAttributesList.additional.length > 0 &&
        (!objAttributesList.under || objAttributesList.under.length === 0)
      ) {
        setItems([
          ...items,
          {
            key: '3',
            label:
              Number(productIsn) === 471391
                ? 'Дополнительные атрибуы обьекта'
                : 'Атрибуты страховщика',
            children: (
              <ObjectCardAdditionalDynamic
                agrIsn={agrIsn}
                objAttributesList={objAttributesList}
                objAttrData={objAttrData}
                userForeignId={userForeignId}
                additionalObjAttributesForm={additionalObjAttributesForm}
                selectedObj={selectedObj}
                dicti={dicti}
                openTypeId={openTypeId}
                productIsn={productIsn}
              />
            ),
          },
        ]);
      } else if (
        !objAttributesList.additional &&
        objAttributesList.under &&
        objAttributesList.under.length > 0
      ) {
        setItems([
          ...items,
          {
            key: '4',
            label: 'Раздел андеррайтера',
            children: (
              <ObjectCardUnderDynamic
                agrIsn={agrIsn}
                objAttributesList={objAttributesList}
                userForeignId={userForeignId}
                objAttrData={objAttrData}
                productIsn={productIsn}
                additionalUnderForm={additionalUnderForm}
                selectedObj={selectedObj}
                dicti={dicti}
              />
            ),
          },
        ]);
      } else if (
        objAttributesList.additional &&
        objAttributesList.additional.length > 0 &&
        objAttributesList.under &&
        objAttributesList.under.length > 0
      ) {
        setItems([
          ...items,
          {
            key: '3',
            label: 'Атрибуты страховщика',
            children: (
              <ObjectCardAdditionalDynamic
                agrIsn={agrIsn}
                objAttributesList={objAttributesList}
                userForeignId={userForeignId}
                objAttrData={objAttrData}
                additionalObjAttributesForm={additionalObjAttributesForm}
                selectedObj={selectedObj}
                dicti={dicti}
                openTypeId={openTypeId}
                productIsn={productIsn}
              />
            ),
          },
          {
            key: '4',
            label: 'Атрибуты андеррайтера',
            children: (
              <ObjectCardUnderDynamic
                agrIsn={agrIsn}
                objAttributesList={objAttributesList}
                userForeignId={userForeignId}
                objAttrData={objAttrData}
                productIsn={productIsn}
                additionalUnderForm={additionalUnderForm}
                selectedObj={selectedObj}
                dicti={dicti}
              />
            ),
          },
        ]);
      }
    }
  }, [objAttributesList, items, selectedObj]);

  return (
    <Modal
      width={'1000px'}
      title={
        <span
          style={{
            color: '#7449ef',
            fontSize: 20,
            fontWeight: 600,
            lineHeight: 1.4,
          }}
        >
          Добавить {modalSetting.item.full_name?.toLowerCase()}
        </span>
      }
      open={true}
      onCancel={closeObjectModal}
      footer={<></>}
    >
      {/* <CustomLoader spinning={isLoading || isLoadingDicti}> */}
      <Tabs defaultActiveKey="1" items={items} type="card" />
      {/* </CustomLoader> */}
    </Modal>
  );
};
export default ObjectCardModalDynamic;
